import createApiClient from "./api";

const client = createApiClient(true)

export const createResource = {
    uploadResource: (payload: FormData) => client.post('upload-file', payload),
    uploadModuleResource: (payload: FormData) => client.post('upload-module-zip', payload),
}